// removed by extract-text-webpack-plugin
module.exports = {"root":"empty-message--root--4AL_xO5M"};


//////////////////
// WEBPACK FOOTER
// ./components/empty-message/styles.css
// module id = ./components/empty-message/styles.css
// module chunks = 0